import {stringify} from "qs";
import {FrontendRequest} from "services-comun/modules/net/request-frontend";
import dominio from "../../portal/ed";
import {IComentario, IDirecto} from "./interface";

export class DirectosWebFrontendRequest extends FrontendRequest {
    /* STATIC */
    private static SERVICIO: string = dominio.get(dominio.SERVICES);


    public static async actualizarComentarios(id: number, last: number): Promise<IDirecto> {
        const params = stringify({
            id,
            last
        });

        return this.get<IDirecto>(`${this.SERVICIO}/web/backoffice/directos-web/refresh/?${params}`).then(resp => resp.data);
    }

    public static async getComentariosAnteriores(id: number, last: number, cantidad: number = 10): Promise<IComentario[]> {
        const params = stringify({
            id,
            last,
            cantidad
        });

        return this.get<IComentario[]>(`${this.SERVICIO}/web/backoffice/directos-web/comentarios/anteriores/?${params}`).then(resp => resp.data);
    }

    /* INSTANCE */
}
